// Реестр стартовых экранов для раннего preload (LCP).
// Ключ — имя первого шага конфига (configToApply[0].name).
//   load — прогрев lazy-чанка стартовой страницы (тот же модуль, что в
//          stepsComponents — webpack дедупит в один чанк).
//   hero / heroDark — мобильная LCP-картинка (.avif) для <link rel="preload">.
// При добавлении новой стартовой страницы добавь сюда одну запись.

// Карусельные экраны: hero = первый слайд (index 0).
import startPageV4Hero from '../steps/start/startPageV4/img/img1.avif';
import startPageV4HeroDark from '../steps/start/startPageV4/img/img1Dark.avif';
import startPageV44Hero from '../steps/start/startPageV44/img/img1.avif';

// bg-pattern экраны: на мобиле (window.innerWidth < 768 → dImg=false)
// рендерится ветка <img src={bg}> → мобильный hero = bg.avif.
import bgV29 from '../steps/start/startPageV29/img/bg.avif';
import bgV30 from '../steps/start/startPageV30/img/bg.avif';
import bgV31 from '../steps/start/startPageV31/img/bg.avif';
import bgV32 from '../steps/start/startPageV32/img/bg.avif';
import bgV33 from '../steps/start/startPageV33/img/bg.avif';
import bgV34 from '../steps/start/startPageV34/img/bg.avif';
import bgV35 from '../steps/start/startPageV35/img/bg.avif';
import bgV36 from '../steps/start/startPageV36/img/bg.avif';
import bgV37 from '../steps/start/startPageV37/img/bg.avif';
import bgV38 from '../steps/start/startPageV38/img/bg.avif';
import bgV39 from '../steps/start/startPageV39/img/bg.avif';
import bgV40 from '../steps/start/startPageV40/img/bg.avif';
import bgV41 from '../steps/start/startPageV41/img/bg.avif';
import bgV42 from '../steps/start/startPageV42/img/bg.avif';
import bgV43 from '../steps/start/startPageV43/img/bg.avif';
import bgV45 from '../steps/start/startPageV45/img/bg.avif';
import bgV46 from '../steps/start/startPageV46/img/bg.avif';

export type StartScreen = {
  load: () => Promise<unknown>;
  hero?: string;
  heroDark?: string;
};

export const startScreens: Record<string, StartScreen> = {
  customV2_startPageV4: {
    load: () => import('../steps/start/startPageV4'),
    hero: startPageV4Hero,
    heroDark: startPageV4HeroDark,
  },
  customV2_startPageV44: {
    load: () => import('../steps/start/startPageV44'),
    hero: startPageV44Hero,
  },
  customV2_startPageV29: { load: () => import('../steps/start/startPageV29'), hero: bgV29 },
  customV2_startPageV30: { load: () => import('../steps/start/startPageV30'), hero: bgV30 },
  customV2_startPageV31: { load: () => import('../steps/start/startPageV31'), hero: bgV31 },
  customV2_startPageV32: { load: () => import('../steps/start/startPageV32'), hero: bgV32 },
  customV2_startPageV33: { load: () => import('../steps/start/startPageV33'), hero: bgV33 },
  customV2_startPageV34: { load: () => import('../steps/start/startPageV34'), hero: bgV34 },
  customV2_startPageV35: { load: () => import('../steps/start/startPageV35'), hero: bgV35 },
  customV2_startPageV36: { load: () => import('../steps/start/startPageV36'), hero: bgV36 },
  customV2_startPageV37: { load: () => import('../steps/start/startPageV37'), hero: bgV37 },
  customV2_startPageV38: { load: () => import('../steps/start/startPageV38'), hero: bgV38 },
  customV2_startPageV39: { load: () => import('../steps/start/startPageV39'), hero: bgV39 },
  customV2_startPageV40: { load: () => import('../steps/start/startPageV40'), hero: bgV40 },
  customV2_startPageV41: { load: () => import('../steps/start/startPageV41'), hero: bgV41 },
  customV2_startPageV42: { load: () => import('../steps/start/startPageV42'), hero: bgV42 },
  customV2_startPageV43: { load: () => import('../steps/start/startPageV43'), hero: bgV43 },
  customV2_startPageV45: { load: () => import('../steps/start/startPageV45'), hero: bgV45 },
  customV2_startPageV46: { load: () => import('../steps/start/startPageV46'), hero: bgV46 },
  start_page_age: { load: () => import('../steps/start/startPageAge') },
};
